// extracted by mini-css-extract-plugin
export default {"mainBelief":"mainBelief_mainBelief__piARz","content":"mainBelief_content__Wyd5D","rightQuote":"mainBelief_rightQuote__d5QQL"};